import { Button, ButtonVariant } from "@mantine/core";
import { IconMessage } from "@tabler/icons-react";
import { useTimer } from "shared/hooks/useTimer";
import { Sizes } from "shared/types/mantine";

type Props = {
  text: string;
  startTime: number;
  error: string | null;
  variant?: ButtonVariant;
  onClick?: () => void;
  loading?: boolean;
  size?: Sizes;
  disabled?: boolean;
};

export const TimerButton = ({
  startTime,
  variant,
  onClick: onCLick,
  text,
  loading,
  size,
  disabled: rawDisabled,
}: Props) => {
  const [restOfTime, handleRestart] = useTimer(startTime);
  const minutes = Math.floor(restOfTime / 60);
  const seconds = restOfTime % 60;
  const tablo = (number: number) => (number < 10 ? "0" + number : number);
  const timer = restOfTime ? `Повторно: ${tablo(seconds)}` : null;
  const disabled = rawDisabled || !!restOfTime;

  const handleClick = async () => {
    onCLick && (await onCLick());
    handleRestart();
  };

  return (
    <Button
      loading={loading}
      leftSection={<IconMessage />}
      onClick={handleClick}
      variant={variant}
      size={size ? size : "lg"}
      disabled={disabled}
    >
      {disabled ? timer : text}
    </Button>
  );
};
